export default __webpack_public_path__ + "static/gallery13-1a8711979ca3d9a438ffeb020576ec75.png";